import React from "react";
import {Box} from "@mui/material";


export const tabContainer = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#ffffff',
};


const FullScreenTab = ({children}) => {
    return (
        <Box>
            <Box sx={tabContainer}>
                {children}
            </Box>
        </Box>
    );
};

export default FullScreenTab;
